import { Typography } from "@material-ui/core";
import React from "react";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import { removeRecommender, showErrorMessage, showSuccessMessage } from "../../../../actions";
import ActionDialog from "../../ActionDialog";
import { resolveErrorMessage } from "../../../../util";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../LoadingSpinner";

const RemoveRecommender = ({ open, onClose, user, fetchUser }) => {
  const [loading, setLoading] = React.useState(false);

  const dispatch = useDispatch();

  const handleClearRecommender = async () => {
    try {
      setLoading(true);
      await removeRecommender(user.id);
      await fetchUser();
      dispatch(showSuccessMessage("app.recommender.clear.success"));
    } catch (e) {
      const errorMessage = resolveErrorMessage(e);
      dispatch(showErrorMessage(errorMessage));
    } finally {
      setLoading(false);
    }
  };

  return (
    <ActionDialog
      title="app.recommender.clear"
      open={open}
      onAccept={handleClearRecommender}
      onClose={onClose}
      user={user}
      maxWidth="xs"
      textConfirm="app.ok"
      textButtonCancel="app.cancel"
    >
      {loading ? (
        <LoadingSpinner
          message={<FormattedMessage id="app.loading.updating" />}
        />
      ) : (
        <Typography variant="body1">
          <FormattedHTMLMessage id="app.recommender.clear.text" />
        </Typography>
      )}
    </ActionDialog>
  );
};

export default RemoveRecommender;
